import React, { FC } from 'react';
import styles from './InfoMessage.module.css';
import Info from './Info';

interface InfoProps {
  message: string;
  display: boolean;
}

const InfoMessage: FC<InfoProps> = (infoProps: InfoProps) => {
  const { message, display } = infoProps;

  return (
    display && (
      <div className={styles['type-open-radius']}>
        <div className={styles.content}>
          <div className={styles['alert-severity']}>
            <div className={styles.img}>
              <Info />
            </div>
          </div>
          <div className={styles['text-wrapper']}>{message}</div>
        </div>
      </div>
    )
  );
};

export default InfoMessage;
